import { Component, ErrorInfo, ReactNode } from 'react';
import i18n from '../../i18n';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-screen bg-neutral-100 dark:bg-dark-bgPrimary flex flex-col justify-center items-center text-center p-6">
          <div className="max-w-md">
            <h1 className="text-4xl font-bold text-danger mb-4">{i18n.t('errors.title')}</h1>
            <p className="text-lg text-neutral-700 dark:text-dark-textSecondary mb-6">
              {i18n.t('errors.description')}
            </p>
            <button onClick={() => window.location.reload()} className="btn-primary">
              {i18n.t('common.refreshPage')}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
